export const useAccessToken = (): string | null => {
  const url = new URL(window.location.href);
  const token = url.searchParams.get('t');
  return token;
};
